export default __webpack_public_path__ + "static/media/litho-demo-gym-fitness.2eb522fc.jpg";